import React from 'react';
import type { OptionProps } from 'react-select';
import { components } from 'react-select';
import type { EntitySearchResult } from './EntitySelect';
import NewSelectOption from './NewSelectOption';
import GroupSelectOption from '../../groups/GroupSelectOption';
import PostSelectOption from '../../post/PostSelectOption';
import TopicSelectOption from '../../topic/TopicSelectOption';
import UserSelectOption from '../../user/UserSelectOption';

const COMPONENT_MAP = {
  group: GroupSelectOption,
  post: PostSelectOption,
  topic: TopicSelectOption,
  user: UserSelectOption,
} as const;

type EntitySelectOptionProps<
  OptionType extends EntitySearchResult,
  IsMulti extends boolean = false,
> = OptionProps<OptionType, IsMulti> & { isFocused: boolean };

const EntitySelectOption = <
  OptionType extends EntitySearchResult,
  IsMulti extends boolean = false,
>(
  props: EntitySelectOptionProps<OptionType, IsMulti>,
) => {
  const { data } = props;

  if (!data.type) {
    return (
      <components.Option {...props}>
        <NewSelectOption {...data} />
      </components.Option>
    );
  }
  const Component = COMPONENT_MAP[data.type];

  return (
    <components.Option {...props}>
      {/* @ts-expect-error */}
      <Component {...data} focused={props.isFocused} />
    </components.Option>
  );
};

export default EntitySelectOption;
